import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "video-container"
};
const _hoisted_2 = ["src"];
import { accessVideoLink } from "@/help/convertVideoLinks";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ViewVideo',
    props: {
        link: {
            type: String,
            default: ""
        }
    },
    setup(__props) {
        const props = __props;
        const embedUrl = computed(() => {
            return accessVideoLink(props.link);
        });
        return (_ctx, _cache) => {
            return (embedUrl.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(), _createElementBlock("iframe", {
                        key: embedUrl.value,
                        src: embedUrl.value,
                        allowfullscreen: "",
                        frameborder: "0"
                    }, null, 8, _hoisted_2))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
